// Pure client helpers for engineer time on site (Session ABU). Shared by the office job-sheet
// detail (Part B) and the weekly timesheet (Part C). No React/DOM dependency so the maths unit
// tests directly.

const MS_PER_MINUTE = 60 * 1000;

function parse(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isNaN(t) ? null : t;
}

// Whole minutes on site between an arrival and departure ISO time. Returns null when either is
// missing/unparseable; a departure before arrival (bad data) clamps to 0, never negative.
export function durationMinutes(arrivalIso: string | null | undefined, departureIso: string | null | undefined): number | null {
  const a = parse(arrivalIso);
  const d = parse(departureIso);
  if (a == null || d == null) return null;
  const mins = (d - a) / MS_PER_MINUTE;
  return mins > 0 ? Math.round(mins) : 0;
}

// Format whole minutes as "Xh Ym" (or "Ym" under an hour, "0m" for zero). null/NaN -> "Not
// recorded" (Part B: a missing arrival or departure is labelled, never shown as a blank).
export function formatDurationHm(minutes: number | null | undefined): string {
  if (minutes == null || !Number.isFinite(minutes)) return "Not recorded";
  const whole = Math.round(minutes);
  if (whole <= 0) return "0m";
  const h = Math.floor(whole / 60);
  const m = whole % 60;
  return h ? (m ? `${h}h ${m}m` : `${h}h`) : `${m}m`;
}
